export default __webpack_public_path__ + "static/media/icon-ua.e12af314.svg";